<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  data () {
    return {}
  },
  methods: {
    /**
     * 验证手机
     *
     * @return {void}
     */
    validateMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )

      return flag
    }
  },
  mounted () {
    if (this.validateMobile()) {
      this.$router.replace("/wap-home")
    } else {
      this.$router.replace("/pc-home")
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue